import { FC } from 'react';

import {
  BasicLayout,
  BasicLayoutProps,
} from './components/BasicLayout/BasicLayout';
import { Content } from './components/Content/Content';
import { Footer } from './components/Footer/Footer';
import { Header } from './components/Header/Header';
import { Main } from './components/Main/Main';
import { Sider } from './components/Sider/Sider';

type CompoundedComponent = FC<BasicLayoutProps> & {
  /** @deprecated
   * We use this as a wrapper for widgets/Header.
   * It's overkill. Need to make simpler layout and use only one header component, not one inside another.
   */
  Header: typeof Header;
  Content: typeof Content;
  Main: typeof Main;
  Sider: typeof Sider;
  Footer: typeof Footer;
};

const Layout = BasicLayout as CompoundedComponent;

Layout.Header = Header;
Layout.Content = Content;
Layout.Main = Main;
Layout.Sider = Sider;
Layout.Footer = Footer;

export { Layout };
